import React, { useContext } from 'react';
import styles from './WorkspacesMyReports.module.scss';
import { useParams } from 'react-router-dom';
import { AppOptionsContext } from 'ui-smartforce-settings';

export const WorkspacesMyReports = (): React.ReactElement<{}> => {
  const { workspaces } = useContext(AppOptionsContext);
  const { workspaceId } = useParams<{ workspaceId: string }>();

  const workspace = workspaces.find((w) => w.id === workspaceId);

  return (
    <div className={styles.workspacesMyReports}>
      <h1>{workspace?.name}</h1>
    </div>
  );
};
